import parse from "html-react-parser";

const Detail = ({ description }) => {
  // Thay thế tất cả <p></p> thành <br />
  // const updatedDescription = description?.replace(/<p><\/p>/g, "<br />");

  return (
    <>
      <div className="ProseMirror text-primary_light">{parse(description)}</div>
    </>
  );
};

export default Detail;
